<template>
<div class="group_table_wrap">
  <el-table
      :data="admins"
      border
      style="width:95.2%;margin:0px auto;" size="medium" >
      <el-table-column
        prop="administrator_id"
        label="id"
        min-width="10">
      </el-table-column>
      <el-table-column
        prop="account"
        label="账号"
        min-width="25">
      </el-table-column>
      <el-table-column
        prop="name"
        label="用户名"
        min-width="25">
      </el-table-column>
      <el-table-column
        prop="group_name"
        label="角色"
        min-width="25">
      </el-table-column>
      <el-table-column
        prop="access_count"
        label="访问次数"
        min-width="25">
      </el-table-column>
      <el-table-column
        label="状态"
        min-width="25">
        <template slot-scope="scope">
          {{scope.row.status===1?'启用':'禁用'}}
        </template>
      </el-table-column>
      <el-table-column
        prop="last_login"
        label="最后访问"
        min-width="25">
      </el-table-column>
      <el-table-column
      label="操作"
      min-width="50">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="fnPopShow(scope.row.administrator_id)">编辑</el-button>
            <el-button
            size="mini"
            @click="useOrNo(scope.row.administrator_id)">{{scope.row.status==1?'禁用':'解禁'}}</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="fnDelAdmin(scope.row.administrator_id)">删除</el-button>
        </template>
      </el-table-column>
   </el-table>

   <el-dialog title="管理员信息修改" :visible.sync="pop_show" append-to-body width="95%">
        <el-form :model="adminForm" :inline="true" status-icon :rules="rulesAdminForm" ref="adminForm" label-width="70px">

          <el-form-item label="用户名：" prop="name1">
            <el-input type="text" v-model="adminForm.name1" autocomplete="off" size="small"></el-input>
          </el-form-item>

          <el-form-item label="角色：" prop="group_id">
            <template>
                <el-select size="small" v-model="adminForm.group_id" placeholder="请选择状态">
                  <el-option
                    v-for="item in options"
                    :label="item.name"
                    :value="item.group_id">
                  </el-option>
                </el-select>
              </template>
          </el-form-item><br>

          <el-form-item>
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button @click="resetForm('adminForm')">重置</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>

</div>
</template>

<script>
import cons from '@/components/constant';

export default {
  name: 'AdminTable',
  props:['admins'],
  data () {
    var validateUserName = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('账号不能为空!'));
        } else {
          var reUser = /^\w{5,20}$/;
          if(reUser.test(value))
          {
            callback()
          }else{
             callback(new Error('账号是5到20位数字、字母或下划线'));
          }
        }
    };
    var validatePassWord = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('用户名不能为空!'));
        } else {
          var reUser = /^\w{5,20}$/;
          if(reUser.test(value))
          {
            callback()
          }else{
             callback(new Error('用户名是5到20位数字、字母或下划线'));
          }
        }
    };
    var validateMobile = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('组名不能为空!'));
        } else {
          var reUser = /^\w{5,20}$/;
          if(reUser.test(value))
          {
            callback()
          }else{
             callback(new Error('组名是5到20位数字、字母或下划线'));
          }
        }
    };
    return {
      pop_show:false,
      edit_id:0,
      options: [],
      adminForm:{
        username:'',
        name1: '',
        group_name:'',
        group_id:'',
        list:[],
        listval:[],
        list2:[],
        listval2:[]
      },
      rulesAdminForm:{
        username: [
            { validator: validateUserName, trigger: 'blur' }
        ],
        name1: [
            { validator: validatePassWord, trigger: 'blur' }
        ],
        group_name: [
            { validator: validateMobile, trigger: 'blur' }
        ]
      }
    }
  },
  methods:{
    fnPopShow(id){
      this.pop_show = true;
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/administrators/'+ id, {
        headers: {
          'Authorization': 'Bearer ' + token
        },
        responseType: 'json',
      })
      .then(dat=>{
         this.edit_id = id;
         this.adminForm.username = dat.data.data.account;
         this.adminForm.name1 = dat.data.data.name;
         this.adminForm.group_name = dat.data.data.group_name;
         this.adminForm.group_id = dat.data.data.group_id;

        this.axios.get(cons.apis + '/v1_0/groups', {
            headers: {
              'Authorization': 'Bearer ' + token
            },
            responseType: 'json'
        })
        .then(dat=>{
            this.options = dat.data.data.groups;
        }).catch(err=>{
           console.log(err);
        });




      }).catch(err=>{
         console.log(err.response);
      });
    },
    useOrNo(id){
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/administrators/'+ id, {
        headers: {
          'Authorization': 'Bearer ' + token
        },
        responseType: 'json',
      })
      .then(dat=>{
        this.axios.put(cons.apis + '/v1_0/administrators/'+id, {
              "status": dat.data.data.status==1?0:1,
            }, {
            headers: {
              'Authorization': 'Bearer ' + token
            },
            responseType: 'json'
        }).then(dat=>{
          this.$message({
            type: 'success',
            message: '修改成功!'
          });
          this.$emit('fnResetTable');
        }).catch(err=>{
          console.log(err.response);
        })


      }).catch(err=>{
         console.log(err.response);
      });
    },
    fnDelAdmin(id){
        this.edit_id = id;
        let token = localStorage.token;
        this.$confirm('此操作将删除该管理员, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios.delete(cons.apis + '/v1_0/administrators/'+this.edit_id,{
              headers: {
                'Authorization': 'Bearer ' + token
              },
              responseType:'json'
          }).then(dat=>{
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.$emit('fnResetTable');
          }).catch(err=>{
            if(err.response.status==404){
               this.$message({
                  type:'info',
                  message:'管理员未找到！'
                });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    submitForm(){
      let token = localStorage.token;
       this.axios.put(cons.apis + '/v1_0/administrators/'+this.edit_id, {
              "account":this.adminForm.username,
              "group_name":this.adminForm.group_name,
              "administrator_id":this.edit_id,
              "group_id":this.adminForm.group_id,
              "name":this.adminForm.name1,
            }, {
            headers: {
              'Authorization': 'Bearer ' + token
            },
            responseType: 'json'
        }).then(dat=>{
          this.$message({
            type: 'success',
            message: '管理员信息修改成功!'
          });
          this.pop_show = false;
          this.resetForm('adminForm');
          this.$emit('fnResetTable');
        }).catch(err=>{
          console.log(err.response);
        })
    },
    resetForm(formName){
      this.$refs[formName].resetFields();
    }
  },
  mounted(){
    // this.fnGetPower();
    // this.fnGetGroup();
  }
}
</script>

<style scoped>
.el-table th,.el-table td{
  text-align:center;
}
</style>



// WEBPACK FOOTER //
// src/components/widget/AdminTable.vue